import { jsonPost, postFormData, jsonGet, commonThinxHeaders } from 'api'

export const createAccount = (firstName, lastName, email, password, phone, preferredLocale) =>
    jsonPost(
        `${THINX_ACCOUNT_URL}/subscription/account/create?X-API-Key=${THINX_BASE_API_URL_API_KEY}`,
        {
            type: 'INDIVIDUAL',
            state: 'PENDING',
            owner: {
                firstName,
                lastName,
                contact: {
                    mobile: [
                        {
                            value: phone,
                        },
                    ],
                    email: [
                        {
                            email,
                            mode: 'EMAIL',
                            primary: true,
                        },
                    ],
                },
            },
            users: [
                {
                    userId: email,
                    email: email,
                    firstName,
                    lastName,
                    desiredPwd: password,
                },
            ],
            contacts: [
                {
                    firstName,
                    lastName,
                    email,
                    phone,
                    contactType: 'BILLING',
                },
            ],
            preferredLocale: preferredLocale,
        },
        commonThinxHeaders()
    ).catch(error => {
        throw new Error(error.message)
    })

export const login = (email, password, translate) =>
    postFormData(`${THINX_BASE_AUTH_URL}/token`, {
        client_id: THINX_CLIENT_ID,
        grant_type: 'password',
        client_secret: '',
        username: email,
        password,
    }).catch(() => {
        throw new Error(translate('auth.login.error'))
    })

export const refreshToken = token =>
    postFormData(`${THINX_BASE_AUTH_URL}/token`, {
        grant_type: 'refresh_token',
        client_id: THINX_CLIENT_ID,
        client_secret: '',
        refresh_token: token,
    }).catch(error => {
        throw new Error(error.message)
    })

export const getCurrentUser = (email, token) =>
    jsonGet(`${THINX_ACCOUNT_URL}/subscription/account/list`, { user: email }, commonThinxHeaders(token)).catch(
        error => {
            throw new Error(error.message)
        }
    )

export const checkUsernameAvailability = email =>
    jsonGet(`${THINX_BASE_USERS_URL}/${THINX_X_TENANT}/users`, {
        username: email,
        briefRepresentation: true,
        'X-API-Key': THINX_BASE_API_URL_API_KEY,
    }).catch(error => {
        throw new Error(error.message)
    })

export const authenticateGrsAccount = token =>
    jsonPost(`${GRS_ACCOUNT_PROXY}/AuthenticateAccount`, undefined, commonThinxHeaders(token, true)).catch(error => {
        throw new Error(error.message)
    })
